<template>
  <div class="back">
    <div class="back__container">
      <div class="back__header">
        <div class="back__header__hamburger">
          <div class="hamburger">
            <a href="#" class="hamburger__a" @click="open_backNavM">
              <img src="@/assets/icon/main_menu_hamburger.png" alt=""
              class="hamburger__img hamburger__img--folded">
            </a>
          </div>
        </div>
        <div class="back__header__logo">
          <a href="#"
          @click="go_page('/')">
            <img src="@/assets/header_logo.png" alt=""
            class="back__header__logo__img">
          </a>
        </div>
      </div>
      <div class="back__navM">
        <transition name="fade">
          <div class="backNavM" v-if="backNavM_is_open"
          @click.prevent="click_shadow($event.target.classList)">
            <div class="backNavM__container">
              <div class="backNavM__body">
                <div class="backNavM__close">
                  <a href="#" class="backNavM__close__a"
                  @click.prevent="close_backNavM">
                    <img src="@/assets/icon/close_menu.png" alt=""
                    class="backNavM__close__img">
                  </a>
                </div>
                <ul class="backNavM__list">
                  <li class="backNavM__item"
                  v-for="(item, index) in navList"
                  :key="index">
                    <a href="#" class="backNavM__a"
                    :class="{'backNavM__a--active' : item.is_active}"
                    @click="change_route(index)">
                      {{item.title}}
                    </a>
                  </li>
                  <li class="backNavM__item">
                    <a href="#" class="backNavM__a backNavM__a--logout"
                    @click="logout">
                      管理員登出
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="back__body">
        <router-view :admin='admin'></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    admin() {
      let obj;
      this.$bus.$on('son_get_data', (data) => {
        obj = data.administrator;
      });
      this.$bus.$emit('son_call_data');
      return obj;
    },
    navList() {
      let arr = [];
      const backChildren = this.$router.options.routes.find((item) => item.path === '/back').children;
      const sorted = backChildren.sort((a, b) => {
        let num = 0;
        num = a.index > b.index ? 1 : -1;
        return num;
      });
      sorted.map((item) => {
        let newI = {};
        newI = item;
        newI.is_active = false;
        return newI;
      });
      arr = JSON.parse(JSON.stringify(sorted));
      return arr;
    },
  },
  data() {
    return {
      backNavM_is_open: false,
    };
  },
  watch: {
    $route() {
      this.close_backNavM();
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    logout() {
      this.$bus.$emit('admin_logout');
      this.go_page('/adminLogin');
    },
    toggle_backNavM() {
      if (this.backNavM_is_open) {
        this.close_backNavM();
      } else {
        this.open_backNavM();
      }
    },
    close_backNavM() {
      this.backNavM_is_open = false;
    },
    open_backNavM() {
      this.backNavM_is_open = true;
    },
    change_route(objIndex) {
      this.navList.forEach((item) => {
        /* eslint-disable */
        item.is_active = false;
        /* eslint-enable */
      });
      const theRoute = this.navList[objIndex];
      theRoute.is_active = true;
      this.go_page(`/back/${theRoute.path}`);
    },
    click_shadow(classlist) {
      const arr = [...classlist];
      if (arr.includes('backNavM')) {
        this.close_backNavM();
      }
    },
  },
  created() {
    if (this.admin.id === '') {
      this.go_page('/adminLogin');
    }
    if (this.$route.path === '/back') {
      this.change_route(0);
    }
  },
};
</script>
